import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SignInButton' })({
    email: {
        color: '#fff',
        opacity: 0.9,
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textDecoration: 'none'
    },
    button: {
        color: '#fff',
        padding: '11px 15px',
        border: '1px solid rgba(255, 255, 255, 0.25)',
        borderRadius: 100,
        background: 'rgba(255, 255, 255, 0.10)',
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        ['&:hover']: {
            background: 'rgba(255, 255, 255, 0.25)'
        },
        ['&:active']: {
            background: 'transparent'
        }
    }
});
